// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes swing {
  0% {
    transform: rotate(0deg);
  }
  10% {
    transform: rotate(15deg);
  }
  30% {
    transform: rotate(0deg);
  }
  40% {
    transform: rotate(-15deg);
  }
  50% {
    transform: rotate(0deg);
  }
  60% {
    transform: rotate(5deg);
  }
  70% {
    transform: rotate(0deg);
  }
  80% {
    transform: rotate(-5deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
@keyframes sonar {
  0% {
    transform: scale(0.9);
    opacity: 1;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
}
.sidebar {
  width: 212px;
  height: 100%;
  max-height: 100%;
  position: fixed;
  top: 0;
  left: 0px;
  z-index: 2100;
  transition: left 0.3s ease;
}
@media screen and (max-width: 768px) {
  .sidebar {
    width: 290px;
  }
}
.sidebar a {
  text-decoration: none;
  transition: color 0.3s ease;
}
.sidebar .sidebar-content {
  max-height: calc(100% - 30px);
  height: calc(100% - 30px);
  overflow-y: auto;
  position: relative;
}
.sidebar .sidebar-content .sidebar-header {
  padding: 10px 20px;
  display: flex;
  align-items: center;
}
.sidebar .sidebar-content .sidebar-header > a {
  text-transform: uppercase;
  font-weight: bold;
  flex-grow: 1;
  text-decoration: none;
}
.sidebar .sidebar-content .sidebar-header #close-sidebar {
  cursor: pointer;
  font-size: 20px;
  transition: color 0.3s ease;
}
.sidebar .sidebar-content .sidebar-profile {
  padding: 20px;
  overflow: hidden;
}
.sidebar .sidebar-content .sidebar-profile .user-pic {
  float: left;
  width: 60px;
  padding: 2px;
  border-radius: 12px;
  margin-right: 15px;
  overflow: hidden;
}
.sidebar .sidebar-content .sidebar-profile .user-pic img {
  object-fit: cover;
  height: 100%;
  width: 100%;
}
.sidebar .sidebar-content .sidebar-profile .user-info {
  float: left;
}
.sidebar .sidebar-content .sidebar-profile .user-info > span {
  display: block;
}
.sidebar .sidebar-content .sidebar-profile .user-info .user-role {
  font-size: 12px;
}
.sidebar .sidebar-content .sidebar-profile .user-info .user-status {
  font-size: 11px;
  margin-top: 4px;
}
.sidebar .sidebar-content .sidebar-profile .user-info .user-status i {
  font-size: 8px;
  margin-right: 4px;
  color: #5cb85c;
}
.sidebar .sidebar-content .sidebar-search > div {
  padding: 4px 4px;
}
.sidebar .sidebar-content .sidebar-search .input-group-append .input-group-text {
  border-left: 0;
}
.sidebar .sidebar-content .sidebar-menu {
  padding-bottom: 10px;
}
.sidebar .sidebar-content .sidebar-menu .header-menu span {
  font-weight: bold;
  font-size: 14px;
  padding: 15px 20px 5px 20px;
  display: inline-block;
}
.sidebar .sidebar-content .sidebar-menu ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.sidebar .sidebar-content .sidebar-menu ul li a {
  display: inline-block;
  width: 100%;
  text-decoration: none;
  position: relative;
  padding: 8px 15px 8px 20px;
}
.sidebar .sidebar-content .sidebar-menu ul li a i {
  margin-right: 10px;
  font-size: 12px;
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 4px;
}
.sidebar .sidebar-content .sidebar-menu ul li a:hover > i::before {
  display: inline-block;
  animation: swing ease-in-out 0.5s 1 alternate;
}
.sidebar .sidebar-content .sidebar-menu ul li a span.label,
.sidebar .sidebar-content .sidebar-menu ul li a span.badge {
  float: right;
  margin-top: 8px;
  margin-left: 5px;
}
.sidebar .sidebar-content .sidebar-menu ul li.menu-movil {
  padding: 4px 0;
}
.sidebar .sidebar-content .sidebar-menu ul li.menu-movil a {
  font-size: 16px;
}
.sidebar .sidebar-content .sidebar-menu ul li:last-child mat-divider {
  display: none;
}
.sidebar .sidebar-content .sidebar-menu .sidebar-dropdown > div > a:after {
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  content: "\\f105";
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background: 0 0;
  position: absolute;
  right: 15px;
  top: 14px;
  transition: transform 0.3s ease;
}
.sidebar .sidebar-content .sidebar-menu .sidebar-dropdown .sidebar-submenu {
  overflow: hidden;
}
.sidebar .sidebar-content .sidebar-menu .sidebar-dropdown .sidebar-submenu ul {
  padding: 5px 0;
}
.sidebar .sidebar-content .sidebar-menu .sidebar-dropdown .sidebar-submenu li {
  padding-left: 25px;
  font-size: 13px;
}
.sidebar .sidebar-content .sidebar-menu .sidebar-dropdown .sidebar-submenu li a:before {
  content: "\\f111";
  font-family: "Font Awesome 5 Free";
  font-weight: 400;
  font-style: normal;
  display: inline-block;
  text-align: center;
  text-decoration: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin-right: 10px;
  font-size: 8px;
}
.sidebar .sidebar-content .sidebar-menu .sidebar-dropdown .sidebar-submenu li a .badge,
.sidebar .sidebar-content .sidebar-menu .sidebar-dropdown .sidebar-submenu li a .label {
  float: right;
  margin-top: 0px;
}
.sidebar .sidebar-content .sidebar-menu .sidebar-dropdown .sidebar-submenu li mat-divider {
  border-top-color: rgba(255, 255, 255, 0.2);
  position: relative;
  left: -16px;
}
.sidebar .sidebar-content .sidebar-menu .sidebar-dropdown .sidebar-submenu li.submenu-movil {
  padding: 4px 0;
}
.sidebar .sidebar-content .sidebar-menu .sidebar-dropdown.active > div > a:after {
  transform: rotate(90deg);
  right: 15px;
}
.sidebar .sidebar-footer {
  position: absolute;
  width: 100%;
  bottom: 0;
  display: flex;
}
.sidebar .sidebar-footer > div {
  flex-grow: 1;
  text-align: center;
  height: 30px;
  line-height: 30px;
  position: static;
  display: flex;
}
.sidebar .sidebar-footer > div > a {
  flex-grow: 1;
}
.sidebar .sidebar-footer > div a .notification {
  position: absolute;
  top: 0;
}
.sidebar .sidebar-footer .dropdown-menu {
  bottom: 31px !important;
  left: 0 !important;
  top: initial !important;
  right: 0 !important;
  transform: none !important;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  font-size: 0.9rem;
}
.sidebar .sidebar-footer .messages .dropdown-item {
  padding: 0.25rem 1rem;
}
.sidebar .sidebar-footer .messages .dropdown-item:active {
  background: transparent !important;
}
.sidebar .sidebar-footer .messages .messages-header {
  padding: 0 1rem;
}
.sidebar .sidebar-footer .messages .messages-header .titulo .titulo-texto {
  text-align: left !important;
}
.sidebar .sidebar-footer .messages .messages-header .titulo .titulo-cerrar {
  text-align: right !important;
}
.sidebar .sidebar-footer .messages .message-content {
  display: flex;
  background: transparent !important;
}
.sidebar .sidebar-footer .messages .message-content:active {
  background: transparent !important;
}
.sidebar .sidebar-footer .messages .message-content .pic {
  width: 40px;
  height: 40px;
  border-radius: 4px;
  overflow: hidden;
}
.sidebar .sidebar-footer .messages .message-content .pic img {
  object-fit: cover;
  height: 100%;
}
.sidebar .sidebar-footer .messages .message-content .content {
  line-height: 1.6;
  padding-left: 5px;
  width: calc(100% - 40px);
}
.sidebar .sidebar-footer .messages .message-content .content .message-title {
  font-size: 13px;
}
.sidebar .sidebar-footer .messages .message-content .content .message-detail {
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.sidebar .sidebar-footer .notifications .dropdown-item {
  padding: 0.25rem 1rem;
}
.sidebar .sidebar-footer .notifications .notifications-header {
  padding: 0 1rem;
}
.sidebar .sidebar-footer .notifications .notification-content {
  display: flex;
}
.sidebar .sidebar-footer .notifications .notification-content .icon {
  width: 40px;
  height: 40px;
}
.sidebar .sidebar-footer .notifications .notification-content .icon i {
  width: 35px;
  height: 35px;
  text-align: center;
  line-height: 35px;
  border-radius: 4px;
}
.sidebar .sidebar-footer .notifications .notification-content .content {
  line-height: 1.6;
  padding-left: 5px;
  width: calc(100% - 40px);
}
.sidebar .sidebar-footer .notifications .notification-content .content .notification-time {
  font-size: 0.7rem;
  color: #828282;
}
.sidebar .sidebar-footer .notifications .notification-content .content .notification-detail {
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.sidebar .sidebar-footer .badge-sonar {
  display: inline-block;
  background: #980303;
  border-radius: 50%;
  height: 8px;
  width: 8px;
  position: absolute;
  top: 0;
}
.sidebar .sidebar-footer .badge-sonar:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  border: 2px solid #980303;
  opacity: 0;
  border-radius: 50%;
  width: 100%;
  height: 100%;
  animation: sonar 1.5s infinite;
}

/*------------------------------default theme---------------------------------*/
.sidebar {
  background-color: #1d1d1d;
  /*PROPIOS ALEX*/
  /*****************/
}
.sidebar li.activo > div > a {
  font-weight: bold;
}
.sidebar li.activo > div > ul > div > li.activo {
  font-weight: bold;
}
.sidebar .sidebar-profile,
.sidebar .sidebar-search,
.sidebar .sidebar-menu {
  border-top: 1px solid #2b2b2b;
}
.sidebar .sidebar-search input.search-menu,
.sidebar .sidebar-search .input-group-text {
  border-color: #2b2b2b;
  box-shadow: none;
}
.sidebar .sidebar-profile .user-info .user-role,
.sidebar .sidebar-profile .user-info .user-status,
.sidebar .sidebar-search input.search-menu,
.sidebar .sidebar-search .input-group-text,
.sidebar .sidebar-header > a,
.sidebar .sidebar-menu ul li a,
.sidebar .sidebar-footer > div > a,
.sidebar #close-sidebar {
  color: #ffffff;
}
.sidebar .sidebar-menu ul li:hover > a,
.sidebar .sidebar-menu .sidebar-dropdown.active > div > a,
.sidebar .sidebar-profile .user-info,
.sidebar .sidebar-header > a:hover,
.sidebar .sidebar-footer > div > a:hover i,
.sidebar #close-sidebar:hover {
  color: #ffffff;
}
.sidebar ul li:hover a i,
.sidebar .sidebar-dropdown .sidebar-submenu li a:hover:before,
.sidebar .sidebar-search input.search-menu:focus + span .sidebar-menu .sidebar-dropdown.active div a i {
  color: #ffffff;
}
.sidebar .sidebar-menu ul li a i,
.sidebar .sidebar-menu .sidebar-dropdown div,
.sidebar .sidebar-search input.search-menu,
.sidebar .sidebar-search .input-group-text {
  border: none;
  margin-left: 1px;
}
.sidebar .sidebar-menu .header-menu span {
  color: #e0e0e0;
}
.sidebar .sidebar-footer {
  background-color: #2b2b2b;
  box-shadow: 0px -1px 5px #131212;
  border-top: 1px solid #3a3a3a;
}
.sidebar .sidebar-footer > div:first-child {
  border-left: none;
}
.sidebar .sidebar-footer > div:last-child {
  border-right: none;
}
.sidebar.sidebar-bg {
  background-image: url(/assets/img/bg1.jpg);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.sidebar.sidebar-bg:before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(204, 32, 32, 0.77);
}
.sidebar.sidebar-bg .sidebar-profile,
.sidebar.sidebar-bg .sidebar-search,
.sidebar.sidebar-bg .sidebar-menu {
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}
.sidebar.sidebar-bg .sidebar-search input.search-menu,
.sidebar.sidebar-bg .sidebar-search .input-group-text {
  border-color: rgba(255, 255, 255, 0.2);
  box-shadow: none;
}
.sidebar.sidebar-bg input.search-menu::placeholder {
  color: #bdbdbd;
}
.sidebar.sidebar-bg .sidebar-menu ul li a i,
.sidebar.sidebar-bg .sidebar-search input.search-menu,
.sidebar.sidebar-bg .sidebar-search .input-group-text {
  background-color: rgba(255, 255, 255, 0.2);
}
.sidebar.sidebar-bg .sidebar-menu .sidebar-dropdown div {
  background-color: rgba(92, 184, 92, 0);
}
.sidebar.sidebar-bg .sidebar-menu .sidebar-dropdown div ul {
  background-color: rgba(255, 255, 255, 0.2);
}
.sidebar.sidebar-bg .sidebar-footer {
  background-color: rgba(185, 0, 0, 0.5);
  box-shadow: 0px -1px 5px rgba(185, 0, 0, 0.5);
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}`, "",{"version":3,"sources":["webpack://./src/app/layout/sidebar-pro/sidebar.component.scss"],"names":[],"mappings":"AAAA;EACE;IACE,uBAAA;EACF;EAEA;IACE,wBAAA;EAAF;EAGA;IACE,uBAAA;EADF;EAIA;IACE,yBAAA;EAFF;EAKA;IACE,uBAAA;EAHF;EAMA;IACE,uBAAA;EAJF;EAOA;IACE,uBAAA;EALF;EAQA;IACE,wBAAA;EANF;EASA;IACE,uBAAA;EAPF;AACF;AAUA;EACE;IACE,qBAAA;IACA,UAAA;EARF;EAWA;IACE,mBAAA;IACA,UAAA;EATF;AACF;AAcA;EACC,YAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;EACA,0BAAA;AAZD;AAaC;EATD;IAUE,YAAA;EAVA;AACF;AAYE;EACE,qBAAA;EACA,2BAAA;AAVJ;AAaG;EACD,6BAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;AAXF;AAaE;EACC,kBAAA;EACA,aAAA;EACA,mBAAA;AAXH;AAaG;EACC,yBAAA;EACA,iBAAA;EACA,YAAA;EACA,qBAAA;AAXJ;AAcG;EACC,eAAA;EACA,eAAA;EACA,2BAAA;AAZJ;AAgBE;EACC,aAAA;EACA,gBAAA;AAdH;AAgBG;EACC,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAdJ;AAgBI;EACA,iBAAA;EACA,YAAA;EACA,WAAA;AAdJ;AAkBG;EACC,WAAA;AAhBJ;AAkBI;EACA,cAAA;AAhBJ;AAmBI;EACA,eAAA;AAjBJ;AAoBI;EACC,eAAA;EACA,eAAA;AAlBL;AAoBK;EACC,cAAA;EACA,iBAAA;EACA,cAAA;AAlBN;AA2BG;EACC,gBAAA;AAzBJ;AA4BG;EACC,cAAA;AA1BJ;AA8BE;EACC,oBAAA;AA5BH;AA8BG;EACC,iBAAA;EACA,eAAA;EACA,2BAAA;EACA,qBAAA;AA5BJ;AA8BG;EACC,qBAAA;EACA,UAAA;EACA,SAAA;AA5BJ;AA8BI;EACC,qBAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,0BAAA;AA5BL;AAgCK;EACC,kBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AA9BN;AAiCK;EACC,qBAAA;EACA,6CAAA;AA/BN;AAoCK;;EAEC,YAAA;EACA,eAAA;EACA,gBAAA;AAlCN;AAuCQ;EACE,cAAA;AArCV;AAsCU;EACE,eAAA;AApCZ;AAwCU;EACE,aAAA;AAtCZ;AA6CI;EACC,kCAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,mCAAA;EACA,kCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,+BAAA;AA3CL;AA8CI;EAEC,gBAAA;AA7CL;AA+CK;EACC,cAAA;AA7CN;AAgDK;EACC,kBAAA;EACA,eAAA;AA9CN;AAiDO;EACC,gBAAA;EACA,kCAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,qBAAA;EACA,mCAAA;EACA,kCAAA;EACA,kBAAA;EACA,cAAA;AA/CR;AAkDO;;EAEC,YAAA;EACA,eAAA;AAhDR;AAmDY;EACE,0CAAA;EACA,kBAAA;EACA,WAAA;AAjDd;AAoDU;EACE,cAAA;AAlDZ;AAsDI;EACC,wBAAA;EACA,WAAA;AApDL;AA6DE;EAEE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,aAAA;AA5DJ;AA8DI;EACE,YAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;AA5DN;AA8DM;EACE,YAAA;AA5DR;AA+DM;EACE,kBAAA;EACA,MAAA;AA7DR;AAiEI;EACE,uBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,0BAAA;EACA,4BAAA;EACA,6BAAA;EACA,iBAAA;AA/DN;AAmEM;EACE,qBAAA;AAjER;AAmEQ;EACE,kCAAA;AAjEV;AAqEM;EACE,eAAA;AAnER;AAqEU;EACE,2BAAA;AAnEZ;AAqEU;EACE,4BAAA;AAnEZ;AAyEM;EACE,aAAA;EACA,kCAAA;AAvER;AAwEQ;EACE,kCAAA;AAtEV;AAyEQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAvEV;AAyEU;EACE,iBAAA;EACA,YAAA;AAvEZ;AA0EQ;EACE,gBAAA;EACA,iBAAA;EACA,wBAAA;AAxEV;AA0EU;EACE,eAAA;AAxEZ;AA2EU;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAzEZ;AAkFM;EACE,qBAAA;AAhFR;AAmFM;EACE,eAAA;AAjFR;AAoFM;EACE,aAAA;AAlFR;AAoFQ;EACE,WAAA;EACA,YAAA;AAlFV;AAoFU;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AAlFZ;AAsFQ;EACE,gBAAA;EACA,iBAAA;EACA,wBAAA;AApFV;AAsFU;EACE,iBAAA;EACA,cAAA;AApFZ;AAuFU;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AArFZ;AA4FI;EACE,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;AA1FN;AA4FM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,yBAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;AA1FR;;AAmGA,+EAAA;AAoBA;EAEE,yBArBoB;EAsBrB,eAAA;EAcA,kBAAA;AAjID;AAqHC;EACC,iBAAA;AAnHF;AAsHC;EACC,iBAAA;AApHF;AA6HC;;;EAGC,6BAAA;AA3HF;AA8HC;;EAEC,qBA7Cc;EA8Cd,gBAAA;AA5HF;AA+HC;;;;;;;;EAQC,cAvDK;AAtEP;AAgIC;;;;;;EAMC,cA7DW;AAjEb;AAiIC;;;EAKC,cArEW;AA5Db;AAoIC;;;;EAKC,YAAA;EACA,gBAAA;AAnIF;AAsIC;EACC,cAnFkB;AAjDpB;AAuIC;EACC,yBA3Fc;EA4Fd,gCAAA;EACA,6BAAA;AArIF;AAwIC;EACC,iBAAA;AAtIF;AAyIC;EACC,kBAAA;AAvIF;AA2IC;EAEC,0CAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AA1IF;AA4IE;EACC,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,yCA7GuB;AA7B1B;AA6IE;;;EAGC,8CAAA;AA3IH;AA8IE;;EAEC,sCAvHiB;EAwHjB,gBAAA;AA5IH;AAuJE;EACC,cA5IuB;AAA1B;AA+IE;;;EAIC,0CA3IiB;AAHpB;AAgJE;EACC,sCAAA;AA9IH;AA+IG;EACC,0CAhJgB;AAGpB;AAgJE;EACC,sCAlJa;EAmJb,6CAAA;EACA,8CAAA;AA9IH","sourcesContent":["@keyframes swing {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  10% {\n    transform: rotate(15deg);\n  }\n\n  30% {\n    transform: rotate(0deg);\n  }\n\n  40% {\n    transform: rotate(-15deg);\n  }\n\n  50% {\n    transform: rotate(0deg);\n  }\n\n  60% {\n    transform: rotate(5deg);\n  }\n\n  70% {\n    transform: rotate(0deg);\n  }\n\n  80% {\n    transform: rotate(-5deg);\n  }\n\n  100% {\n    transform: rotate(0deg);\n  }\n}\n\n@keyframes sonar {\n  0% {\n    transform: scale(.9);\n    opacity: 1;\n  }\n\n  100% {\n    transform: scale(2);\n    opacity: 0;\n  }\n}\n\n\n\n.sidebar {\n\twidth: 212px;\n\theight: 100%;\n\tmax-height: 100%;\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0px;\n\tz-index: 2100; //para que quede mas alto que el ng-loading que es de 2000\n\ttransition: left .3s ease;\n\t@media screen and (max-width: 768px) {\n\t\twidth: 290px;\n\t}\n\n  a {\n    text-decoration: none;\n    transition: color .3s ease;\n  }\n\n  \t.sidebar-content {\n\t\tmax-height: calc(100% - 30px);\n\t\theight: calc(100% - 30px);\n\t\toverflow-y: auto;\n\t\tposition: relative;\n\n\t\t.sidebar-header {\n\t\t\tpadding: 10px 20px;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\n\t\t\t>a {\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tfont-weight: bold;\n\t\t\t\tflex-grow: 1;\n\t\t\t\ttext-decoration: none;\n\t\t\t}\n\n\t\t\t#close-sidebar {\n\t\t\t\tcursor: pointer;\n\t\t\t\tfont-size: 20px;\n\t\t\t\ttransition: color .3s ease;\n\t\t\t}\n\t\t}\n\n\t\t.sidebar-profile {\n\t\t\tpadding: 20px;\n\t\t\toverflow: hidden;\n\n\t\t\t.user-pic {\n\t\t\t\tfloat: left;\n\t\t\t\twidth: 60px;\n\t\t\t\tpadding: 2px;\n\t\t\t\tborder-radius: 12px;\n\t\t\t\tmargin-right: 15px;\n\t\t\t\toverflow: hidden;\n\n\t\t\t\timg {\n\t\t\t\tobject-fit: cover;\n\t\t\t\theight: 100%;\n\t\t\t\twidth: 100%;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.user-info {\n\t\t\t\tfloat: left;\n\n\t\t\t\t>span {\n\t\t\t\tdisplay: block;\n\t\t\t\t}\n\n\t\t\t\t.user-role {\n\t\t\t\tfont-size: 12px;\n\t\t\t\t}\n\n\t\t\t\t.user-status {\n\t\t\t\t\tfont-size: 11px;\n\t\t\t\t\tmargin-top: 4px;\n\n\t\t\t\t\ti {\n\t\t\t\t\t\tfont-size: 8px;\n\t\t\t\t\t\tmargin-right: 4px;\n\t\t\t\t\t\tcolor: #5cb85c;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t}\n\n\t\t.sidebar-search {\n\n\t\t\t>div {\n\t\t\t\tpadding: 4px 4px;\n\t\t\t}\n\n\t\t\t.input-group-append .input-group-text {\n\t\t\t\tborder-left: 0;\n\t\t\t}\n\t\t}\n\n\t\t.sidebar-menu {\n\t\t\tpadding-bottom: 10px;\n\n\t\t\t.header-menu span {\n\t\t\t\tfont-weight: bold;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tpadding: 15px 20px 5px 20px;\n\t\t\t\tdisplay: inline-block;\n\t\t\t}\n\t\t\tul {\n\t\t\t\tlist-style-type: none;\n\t\t\t\tpadding: 0;\n\t\t\t\tmargin: 0;\n\n\t\t\t\tli a {\n\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\ttext-decoration: none;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tpadding: 8px 15px 8px 20px;\n\n\n\n\t\t\t\t\ti {\n\t\t\t\t\t\tmargin-right: 10px;\n\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t\twidth: 30px;\n\t\t\t\t\t\theight: 30px;\n\t\t\t\t\t\tline-height: 30px;\n\t\t\t\t\t\ttext-align: center;\n\t\t\t\t\t\tborder-radius: 4px;\n\t\t\t\t\t}\n\n\t\t\t\t\t&:hover>i::before {\n\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\tanimation: swing ease-in-out .5s 1 alternate;\n\t\t\t\t\t}\n\n\n\n\t\t\t\t\tspan.label,\n\t\t\t\t\tspan.badge {\n\t\t\t\t\t\tfloat: right;\n\t\t\t\t\t\tmargin-top: 8px;\n\t\t\t\t\t\tmargin-left: 5px;\n\t\t\t\t\t}\n\n\n\t\t\t\t}\n        li.menu-movil{\n          padding: 4px 0;\n          a{\n            font-size: 16px;\n          }\n        }\n        li:last-child{\n          mat-divider {\n            display: none\n          }\n        }\n\n\t\t\t}\n\n\t\t\t.sidebar-dropdown {\n\t\t\t\t>div>a:after {\n\t\t\t\t\tfont-family: \"Font Awesome 5 Free\";\n\t\t\t\t\tfont-weight: 900;\n\t\t\t\t\tcontent: \"\\f105\";\n\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\tfont-style: normal;\n\t\t\t\t\tfont-variant: normal;\n\t\t\t\t\ttext-rendering: auto;\n\t\t\t\t\t-webkit-font-smoothing: antialiased;\n\t\t\t\t\t-moz-osx-font-smoothing: grayscale;\n\t\t\t\t\ttext-align: center;\n\t\t\t\t\tbackground: 0 0;\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tright: 15px;\n\t\t\t\t\ttop: 14px;\n\t\t\t\t\ttransition: transform .3s ease;\n\t\t\t\t}\n\n\t\t\t\t.sidebar-submenu {\n\t\t\t\t\t// display: none;\n\t\t\t\t\toverflow: hidden;\n\n\t\t\t\t\tul {\n\t\t\t\t\t\tpadding: 5px 0;\n\t\t\t\t\t}\n\n\t\t\t\t\tli {\n\t\t\t\t\t\tpadding-left: 25px;\n\t\t\t\t\t\tfont-size: 13px;\n\n\t\t\t\t\t\ta {\n\t\t\t\t\t\t\t&:before {\n\t\t\t\t\t\t\t\tcontent: \"\\f111\";\n\t\t\t\t\t\t\t\tfont-family: \"Font Awesome 5 Free\";\n\t\t\t\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\t\t\t\tfont-style: normal;\n\t\t\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\t\t\ttext-align: center;\n\t\t\t\t\t\t\t\ttext-decoration: none;\n\t\t\t\t\t\t\t\t-webkit-font-smoothing: antialiased;\n\t\t\t\t\t\t\t\t-moz-osx-font-smoothing: grayscale;\n\t\t\t\t\t\t\t\tmargin-right: 10px;\n\t\t\t\t\t\t\t\tfont-size: 8px;\n\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t.badge,\n\t\t\t\t\t\t\t.label {\n\t\t\t\t\t\t\t\tfloat: right;\n\t\t\t\t\t\t\t\tmargin-top: 0px;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n            mat-divider{\n              border-top-color: rgba(255, 255, 255, 0.2);\n              position: relative;\n              left: -16px;\n            }\n\t\t\t\t\t}\n          li.submenu-movil{\n            padding: 4px 0;\n          }\n\t\t\t\t}\n\n\t\t\t\t&.active>div>a:after {\n\t\t\t\t\ttransform: rotate(90deg);\n\t\t\t\t\tright: 15px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t}\n\n\n  }\n\n  .sidebar-footer {\n\n    position: absolute;\n    width: 100%;\n    bottom: 0;\n    display: flex;\n\n    >div {\n      flex-grow: 1;\n      text-align: center;\n      height: 30px;\n      line-height: 30px;\n      position: static;\n      display: flex;\n\n      >a {\n        flex-grow: 1;\n      }\n\n      a .notification {\n        position: absolute;\n        top: 0;\n      }\n    }\n\n    .dropdown-menu {\n      bottom: 31px !important;\n      left: 0 !important;\n      top: initial !important;\n      right: 0 !important;\n      transform: none !important;\n      border-bottom-left-radius: 0;\n      border-bottom-right-radius: 0;\n      font-size: .9rem;\n    }\n\n    .messages {\n      .dropdown-item {\n        padding: .25rem 1rem;\n\n        &:active{\n          background: transparent !important;\n        }\n      }\n\n      .messages-header {\n        padding: 0 1rem;\n        .titulo{\n          .titulo-texto{\n            text-align: left !important;\n          }\n          .titulo-cerrar{\n            text-align: right !important;\n          }\n\n        }\n      }\n\n      .message-content {\n        display: flex;\n        background: transparent !important;\n        &:active{\n          background: transparent !important;\n        }\n\n        .pic {\n          width: 40px;\n          height: 40px;\n          border-radius: 4px;\n          overflow: hidden;\n\n          img {\n            object-fit: cover;\n            height: 100%;\n          }\n        }\n        .content {\n          line-height: 1.6;\n          padding-left: 5px;\n          width: calc(100% - 40px);\n\n          .message-title {\n            font-size: 13px;\n          }\n\n          .message-detail {\n            font-size: 12px;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n          }\n\n        }\n      }\n\n    }\n\n    .notifications {\n      .dropdown-item {\n        padding: .25rem 1rem;\n      }\n\n      .notifications-header {\n        padding: 0 1rem;\n      }\n\n      .notification-content {\n        display: flex;\n\n        .icon {\n          width: 40px;\n          height: 40px;\n\n          i {\n            width: 35px;\n            height: 35px;\n            text-align: center;\n            line-height: 35px;\n            border-radius: 4px;\n          }\n        }\n\n        .content {\n          line-height: 1.6;\n          padding-left: 5px;\n          width: calc(100% - 40px);\n\n          .notification-time {\n            font-size: .7rem;\n            color: #828282;\n          }\n\n          .notification-detail {\n            font-size: 12px;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n          }\n        }\n      }\n    }\n\n\n    .badge-sonar {\n      display: inline-block;\n      background: #980303;\n      border-radius: 50%;\n      height: 8px;\n      width: 8px;\n      position: absolute;\n      top: 0;\n\n      &:after {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 0;\n        border: 2px solid #980303;\n        opacity: 0;\n        border-radius: 50%;\n        width: 100%;\n        height: 100%;\n        animation: sonar 1.5s infinite;\n      }\n    }\n\n\n  }\n}\n\n\n/*------------------------------default theme---------------------------------*/\n$bg-sidebar-wrapper : #1d1d1d;\n$border-color : #2b2b2b;\n$footer-top-border-color :#3a3a3a;\n$color:#ffffff;\n$color-search-placeholder:#bdbdbd;\n$header-menu-color :#e0e0e0;\n$hover-color:#ffffff;\n$shadow-color:#131212;\n$bg-scrollbar :#636363;\n\n// colors with backgound image\n$img-bg-sidebar-wrapper : rgba(204, 32, 32, 0.77);\n$img-border-color : rgba(255, 255, 255, 0.2);\n$color-activo : rgba(255, 255, 255, 0.2);\n$img-bg-footer :rgba(185, 0, 0, 0.5);\n$img-shadow-color:rgba(0, 0, 0, 0.5);\n\n\n\n.sidebar {\n\n  background-color: $bg-sidebar-wrapper;\n\t/*PROPIOS ALEX*/\n\n\tli.activo>div>a {\n\t\tfont-weight: bold;\n\t\t// background-color: $color-activo;\n\t}\n\tli.activo>div>ul>div>li.activo {\n\t\tfont-weight: bold;\n\t\t// background-color: $color-activo;\n\t}\n\t// .sidebar-dropdown > div > a :after {\n\n\t// }\n\n\t/*****************/\n\n\t.sidebar-profile,\n\t.sidebar-search,\n\t.sidebar-menu {\n\t\tborder-top: 1px solid $border-color;\n\t}\n\n\t.sidebar-search input.search-menu,\n\t.sidebar-search .input-group-text {\n\t\tborder-color: $border-color;\n\t\tbox-shadow: none;\n\t}\n\n\t.sidebar-profile .user-info .user-role,\n\t.sidebar-profile .user-info .user-status,\n\t.sidebar-search input.search-menu,\n\t.sidebar-search .input-group-text,\n\t.sidebar-header>a,\n\t.sidebar-menu ul li a,\n\t.sidebar-footer>div>a,\n\t#close-sidebar {\n\t\tcolor: $color;\n\t}\n\n\t.sidebar-menu ul li:hover>a,\n\t.sidebar-menu .sidebar-dropdown.active>div>a,\n\t.sidebar-profile .user-info,\n\t.sidebar-header>a:hover,\n\t.sidebar-footer>div>a:hover i,\n\t#close-sidebar:hover {\n\t\tcolor: $hover-color;\n\t}\n\n\tul li:hover a i,\n\t.sidebar-dropdown .sidebar-submenu li a:hover:before,\n\t.sidebar-search input.search-menu:focus+span\n\t.sidebar-menu .sidebar-dropdown.active div a i\n\t{\n\t\tcolor: $hover-color;\n\t}\n\n\t.sidebar-menu ul li a i,\n\t.sidebar-menu .sidebar-dropdown div,\n\t.sidebar-search input.search-menu,\n\t.sidebar-search .input-group-text {\n\t\t// background-color: $border-color;\n\t\tborder: none;\n\t\tmargin-left: 1px;\n\t}\n\n\t.sidebar-menu .header-menu span {\n\t\tcolor: $header-menu-color;\n\t}\n\n\t.sidebar-footer {\n\t\tbackground-color: $border-color;\n\t\tbox-shadow: 0px -1px 5px $shadow-color;\n\t\tborder-top: 1px solid $footer-top-border-color;\n\t}\n\n\t.sidebar-footer>div:first-child {\n\t\tborder-left: none;\n\t}\n\n\t.sidebar-footer>div:last-child {\n\t\tborder-right: none;\n\t}\n\n\t// styles with background image\n\t&.sidebar-bg {\n\n\t\tbackground-image: url(/assets/img/bg1.jpg);\n\t\tbackground-size: cover;\n\t\tbackground-position: center;\n\t\tbackground-repeat: no-repeat;\n\n\t\t&:before {\n\t\t\tcontent: '';\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\tright: 0;\n\t\t\tbottom: 0;\n\t\t\tleft: 0;\n\t\t\tbackground-color: $img-bg-sidebar-wrapper;\n\t\t}\n\n\t\t.sidebar-profile,\n\t\t.sidebar-search,\n\t\t.sidebar-menu {\n\t\t\tborder-top: 1px solid $img-border-color;\n\t\t}\n\n\t\t.sidebar-search input.search-menu,\n\t\t.sidebar-search .input-group-text {\n\t\t\tborder-color: $img-border-color;\n\t\t\tbox-shadow: none;\n\t\t}\n\t\tinput.search-menu::-webkit-input-placeholder {\n\t\t\tcolor: $color-search-placeholder;\n\t\t}\n\t\tinput.search-menu::-moz-placeholder {\n\t\t\tcolor: $color-search-placeholder;\n\t\t}\n\t\tinput.search-menu::-ms-input-placeholder {\n\t\t\tcolor: $color-search-placeholder;\n\t\t}\n\t\tinput.search-menu::placeholder {\n\t\t\tcolor: $color-search-placeholder;\n\t\t}\n\n\t\t.sidebar-menu ul li a i,\n\t\t// .sidebar-menu .sidebar-dropdown div,\n\t\t.sidebar-search input.search-menu,\n\t\t.sidebar-search .input-group-text {\n\t\t\tbackground-color: $img-border-color;\n\t\t}\n\t\t.sidebar-menu .sidebar-dropdown div{\n\t\t\tbackground-color: #5cb85c00; //transparente...\n\t\t\tul {\n\t\t\t\tbackground-color: $img-border-color;\n\t\t\t}\n\t\t}\n\t\t.sidebar-footer {\n\t\t\tbackground-color: $img-bg-footer;\n\t\t\tbox-shadow: 0px -1px 5px $img-bg-footer;\n\t\t\tborder-top: 1px solid $img-border-color;\n\t\t}\n\n\t}\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
